(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["brand-slider"] && !Shopify.designMode) return;
  try {
    
new themeVendor.Flickity(document.querySelector("[data-brand-slider]"), {
      pageDots: false,
      contain: true,
      wrapAround: true,
      cellAlign: 'center',
      arrowShape: 'M29.3333 20H10.6667 M20 10.6667L10.6667 20L20 29.3333',
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-featured-collection"] && !Shopify.designMode) return;
  try {
    
new themeVendor.Flickity(document.querySelector(".custom-featured-collection-slider"), {
      pageDots: false,
      contain: true,
      wrapAround: true,
      cellAlign: 'center',
      arrowShape: 'M29.3333 20H10.6667 M20 10.6667L10.6667 20L20 29.3333',
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["special-benefits-section"] && !Shopify.designMode) return;
  try {
    

  // JavaScript code for tab functionality (you can place this in a separate .js file)
  const tabLinks = document.querySelectorAll('.tab-link');
  const tabContent = document.querySelectorAll('.tab-pane');

  tabLinks.forEach((link) => {
    link.addEventListener('click', () => {
      const tabId = link.getAttribute('data-tab');
      tabContent.forEach((content) => {
        content.classList.remove('active');
      });
      document.getElementById(tabId).classList.add('active');

      tabLinks.forEach((tabLink) => {
        tabLink.classList.remove('active');
      });
      link.classList.add('active');
    });
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonial-slider"] && !Shopify.designMode) return;
  try {
    
new themeVendor.Flickity(document.querySelector("[data-testimonial-slider]"), {
      pageDots: false,
      contain: true,
      wrapAround: true,
      cellAlign: 'center',
      arrowShape: 'M29.3333 20H10.6667 M20 10.6667L10.6667 20L20 29.3333'
    });

  } catch(e) { console.error(e); }
})();
})();
